import React from "react";

import { ACTION } from "./constants";

import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@material-ui/core";

const DialogRender = ({
  handleDownloadButton,
  handleDeleteButton,
  setCheckedList,
  currentAction,
  setCurrentAction,
  dialogIsOpen,
  setDialogIsOpen,
  checkedList,
}) => {
  return (
    <Dialog
      open={dialogIsOpen}
      onClose={() => {
        setDialogIsOpen(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {currentAction} template
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to {currentAction} <b>{checkedList.length}</b>{" "}
          {`${checkedList.length > 1 ? "templates" : "template"}`} from S3
          bucket?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setDialogIsOpen(false)} color="primary">
          Disagree
        </Button>
        <Button
          onClick={() => {
            currentAction === ACTION.download &&
              handleDownloadButton(checkedList);
            currentAction === ACTION.delete && handleDeleteButton(checkedList);
            setCheckedList([]);
            setCurrentAction("");
            setDialogIsOpen(false);
          }}
          color="primary"
          autoFocus
        >
          Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogRender;
